const { REACT_APP_API_PLACEHOLDER } = process.env
export const ROOMS                  = REACT_APP_API_PLACEHOLDER + '/hotels/'


// WEBPACK FOOTER //
// ./src/features/Hotel/apiConst.js